import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { withServerSideProxy } from './proxy';
const windowLogHelpers = {
  logError: function logError() {
    var _window$apphealth;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_window$apphealth = window.apphealth) === null || _window$apphealth === void 0 ? void 0 : _window$apphealth.captureError(...args);
  },
  logWarning: function logWarning() {
    var _window$apphealth2;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return (_window$apphealth2 = window.apphealth) === null || _window$apphealth2 === void 0 ? void 0 : _window$apphealth2.captureWarning(...args);
  },
  logMessage: function logMessage() {
    var _window$apphealth3;

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return (_window$apphealth3 = window.apphealth) === null || _window$apphealth3 === void 0 ? void 0 : _window$apphealth3.captureMessage(...args);
  }
};

const windowHelpers = _objectSpread(_objectSpread({}, windowLogHelpers), {}, {
  getLocale: () => {
    var _window$MD;

    return ((_window$MD = window.MD) === null || _window$MD === void 0 ? void 0 : _window$MD.config.get('lang')) || '';
  },
  getFiredEvents: event => {
    var _window$MD2;

    return (_window$MD2 = window.MD) !== null && _window$MD2 !== void 0 && _window$MD2.firedEvents ? window.MD.firedEvents[event] || [] : [];
  },
  clearFiredEvents: event => {
    var _window$MD3;

    if ((_window$MD3 = window.MD) !== null && _window$MD3 !== void 0 && _window$MD3.firedEvents) {
      window.MD.firedEvents[event] = [];
    }
  },
  scrollToTop: () => window.scroll(0, 0),
  scrollToElementById: function scrollToElementById(elementId) {
    let containerClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'site-content';
    const {
      document
    } = window;
    const container = document.getElementsByClassName(containerClass)[0];
    const elementScrollTo = document.getElementById(elementId);
    if (!container || !elementScrollTo) return;

    if (container instanceof HTMLElement) {
      window.scroll({
        top: elementScrollTo.getBoundingClientRect().top - container.getBoundingClientRect().top - container.offsetTop,
        behavior: 'smooth'
      });
    }
  },
  navigateToPage: path => {
    window.location.href = path;
  },
  redirectToPage: page => window.location.replace(page),
  reloadPage: () => window.location.reload(),
  preventLeave: unloadEvent => {
    unloadEvent.preventDefault(); // Workaround for chrome not supporting the above recommended way, for more details see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event

    unloadEvent.returnValue = true; // eslint-disable-line no-param-reassign

    return true;
  },
  toggleOneTrustInfoDisplay: () => {
    var _window$OneTrust;

    (_window$OneTrust = window.OneTrust) === null || _window$OneTrust === void 0 ? void 0 : _window$OneTrust.ToggleInfoDisplay();
  },
  openBrowsingContext: function openBrowsingContext() {
    return window.open(...arguments);
  },
  getUserAgent: () => window.navigator.userAgent,
  getBrowserWidth: () => window.innerWidth
});

const safeWindowHelpers = withServerSideProxy(windowHelpers, {
  getLocale: () => '',
  getFiredEvents: () => [],
  preventLeave: () => true,
  openBrowsingContext: () => null,
  getUserAgent: () => '',
  getBrowserWidth: () => 0,
  // Server console logs are outputed and forwarded to kibana, next-logger provides automated structure

  /* eslint-disable no-console  */
  logError: (error, context) => console.error(error, context),
  logWarning: (warning, context) => console.warn(warning, context),
  logMessage: (message, context) => console.log(message, context)
  /* eslint-enable no-console */

});
export const {
  getLocale,
  getFiredEvents,
  clearFiredEvents,
  scrollToTop,
  scrollToElementById,
  navigateToPage,
  redirectToPage,
  reloadPage,
  preventLeave,
  toggleOneTrustInfoDisplay,
  openBrowsingContext,
  logWarning,
  logError,
  logMessage,
  getUserAgent,
  getBrowserWidth
} = safeWindowHelpers;